<div class="order-summary-section">
  <tix-card *ngIf="!loading" class="order-sauumary-card">
    <tix-card-content>
      <tix-card-title *ngIf="!thankYouMessage">
        <h3 class="thankyou-text">Thank you for your purchase.</h3>
        <h3 class="thankyou-text">We hope you enjoy the show.</h3>
      </tix-card-title>
      <tix-card-title *ngIf="thankYouMessage">
        <h3 class="thankyou-text">{{ thankYouMessage }}</h3>
      </tix-card-title>
      <div
        class="w-full flex justify-center mt-5"
        *ngIf="venue$ | async as venue"
      >
        <button
          [routerLink]="venueRoute(venue)"
          tix-button
          (click)="trackButtonClick('Explore More Events')"
        >
          Explore More Events
        </button>
      </div>
    </tix-card-content>
    <div class="button-section">
      <div class="buttons-wrapper">
        <div class="w-[150px]">
          <div *ngIf="downloadAnimation" class="mx-16">
            <mat-spinner class="mx-auto" [diameter]="20"></mat-spinner>
          </div>
          <button
            *ngIf="!downloadAnimation"
            (click)="downloadTickets(reservationId)"
            tix-button
          >
            Download Tickets
          </button>
        </div>

        <button
          class="google-wallet-button"
          *ngIf="shouldShowGoogleWalletButton()"
          (click)="openGoogleWalletUrl(reservationId)"
        >
          <div *ngIf="walletAnimation" class="mx-10">
            <mat-spinner class="mx-auto" [diameter]="20"></mat-spinner>
          </div>
          <div *ngIf="!walletAnimation">
            <tix-icon svgIcon="google-wallet-icon"></tix-icon>
          </div>
        </button>
        <button
          class="apple-wallet-button"
          *ngIf="shouldShowAppleWalletButton()"
          (click)="openAppleWalletUrl(reservationId)"
        >
          <div *ngIf="walletAnimation" class="mx-8">
            <mat-spinner class="mx-auto" [diameter]="20"></mat-spinner>
          </div>
          <div *ngIf="!walletAnimation">
            <tix-icon svgIcon="apple-wallet-icon"></tix-icon>
          </div>
        </button>
      </div>
    </div>
  </tix-card>
</div>
